import { LoginAction } from "@/component/login/actions";
import encrypt from "@/tools/encrypt";
import { getSessionObject, setLoginUrlCache, setPlatformTokenInfo, Utils } from '@/tools/utils';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Input, notification, Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import LoginSwitch from '../login/components/login-switch';
import { getMerchantList, getMerchantToken, removeLoginData, setLoginData } from '../utils';
import './login-merchant.less';


const { TabPane } = Tabs;

const layout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 }
};
const tailLayout = {
    wrapperCol: { offset: 0, span: 24 }
};


const LoginMerchant = (props) => {
    const { form } = props;

    const history = useHistory();
    const [btnLoading, setBtnLoading] = useState(false);
    const [isAgree, setIsAgree] = useState(false);

    // 存在loginData则说明已经登录，需要进行选择商户或者统一密码
    useEffect(() => {
        const loginData = getSessionObject('loginData') || {};
        if (loginData.needUnifiedPwd) {
            history.push('/login/unify');
            return;
        }
        // 判断是否存在多个关联商户，需要选择所登录的商户
        if (loginData.merchants && loginData.merchants.total > 1) {
            history.push('/login/select');
            return;
        }
    }, []);

    const loginSuccess = (data) => {
        const _token = data.token_type + data.access_token;
        let { access_token, token_type, refresh_token, expires_in } = data;
        const _tokenInfo = {
            access_token,
            token_type,
            refresh_token,
            expires_in,
            loginWay: 'newLogin',
            nowTime: Date.parse(new Date()) / 1000
        };
        setPlatformTokenInfo(JSON.stringify(_tokenInfo));
        setLoginUrlCache();//缓存登陆url
        removeLoginData();
        props.setToken(_token);
        Utils.sensorsQuick('商户号登录');
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    if(!isAgree) {
                        notification.warning({
                            message: '请阅读并同意协议',
                        });
                        return;
                    }
                    setBtnLoading(true);
                    const params = {
                        tenantCode: values.tenantCode,
                        username: values.username,
                        password: encrypt(values.password),
                    };
                    const res = await getMerchantList(params, 'username');
                    window.localStorage.setItem('loginType', 'merchant');
                    if (res.status === 200) {
                        const data = res.data;
                        setLoginData({
                            params: {...params},
                            loginType: 'username',
                            merchants: {
                                list: data.rows,
                                total: data.total
                            },
                            needUnifiedPwd: data.needUnifiedPwd
                        });
                        // 判断是否需要设置统一密码
                        if (data && data.needUnifiedPwd) {
                            history.push({
                                pathname: '/login/unify',
                            });
                            return;
                        }

                        const getTokenParams = {
                            ...params,
                            orgId: data.rows[0].orgId
                        }
                        localStorage.setItem('orgId', data.rows[0].orgId);
                        const tokenRes = await getMerchantToken(getTokenParams, 'username');
                        loginSuccess(tokenRes.data);
                        history.replace('/homePage');
                    }
                } finally {
                    setBtnLoading(false);
                }

            }
        })
    };

    return (
        <div style={{ padding: '10px 56px 0 20px', margin: '26px 0 48px' }}>
            <Tabs className='login-merchant' defaultActiveKey="merchant" centered>
                <TabPane tab='商户号登录' key='merchant'>
                    <Form
                        {...layout}
                        onSubmit={handleSubmit}
                    >
                        <Form.Item>
                            {
                                form.getFieldDecorator('tenantCode', {
                                    validateFirst: true,
                                    validateTrigger: 'onBlur',
                                    rules: [{
                                        required: true,
                                        message: '请输入商户号',
                                    }],
                                })(
                                    <Input size="large" maxLength={200} placeholder="请输入商户号" allowClear />
                                )
                            }
                        </Form.Item>

                        <Form.Item>
                            {
                                form.getFieldDecorator('username', {
                                    validateFirst: true,
                                    validateTrigger: 'onBlur',
                                    rules: [{
                                        required: true,
                                        message: '请输入用户名',
                                    }],
                                })(
                                    <Input size="large" maxLength={200} placeholder="请输入用户名" allowClear />
                                )
                            }
                        </Form.Item>

                        <Form.Item>
                            {
                                form.getFieldDecorator('password', {
                                    validateFirst: true,
                                    validateTrigger: 'onBlur',
                                    rules: [{
                                        required: true,
                                        message: '请输入密码',
                                    }],
                                })(
                                    <Input.Password
                                        size="large"
                                        maxLength={20}
                                        placeholder="请输入登录密码"
                                        visibilityToggle={Boolean(form.getFieldValue('password'))}
                                        allowClear
                                    />
                                )
                            }
                        </Form.Item>

                        <div className="checkAgree">
                            <img
                                className="select-icon"
                                src={
                                    isAgree ?
                                        require('../../img/selected.png') :
                                        require('../../img/unselect.png')
                                }
                                onClick={() => setIsAgree(!isAgree)}
                            />
                            {/*<Checkbox.Group>*/}
                            {/*    <Checkbox value={1} />*/}
                            {/*</Checkbox.Group>*/}
                            同意<a href="https://cdn.zhongbaounion.com/share/register/user-agreement.html" target="_blank" onClick={() => {
                            // Utils.customTrack('MerchantLoginClick', {
                            //     element_content: '用户协议'
                            // });
                        }} rel="noreferrer">《用户协议》</a>和<a href="https://cdn.zhongbaounion.com/share/register/privacy-policy.html" target="_blank" onClick={() => {
                            // Utils.customTrack('MerchantLoginClick', {
                            //     element_content: '隐私协议'
                            // });
                        }} rel="noreferrer">《隐私政策》</a>
                        </div>

                        <Form.Item {...tailLayout}>
                            <Button
                                loading={btnLoading}
                                type="primary"
                                size="large"
                                block
                                htmlType="submit"
                                className='submit-btn'
                            >
                                登录
                            </Button>
                        </Form.Item>
                    </Form>
                </TabPane>
            </Tabs>
            <LoginSwitch></LoginSwitch>
        </div>
    );
};

const WrappedForm = Form.create()(LoginMerchant);
export default connect(null, { ...LoginAction })(WrappedForm)
